import React from 'react';
import styled from 'astroturf/react';
import PremiumIcon from 'js/premium/PremiumIcon';
import _Button from "common-Button.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/Unibrows/common.tsx?styleId=Button";
import _Container from "common-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/Unibrows/common.tsx?styleId=Container";


const Button = /*#__PURE__*/styled("button", null, {
  displayName: "Button",
  styles: _Button
});

export const Container = /*#__PURE__*/styled("section", null, {
  displayName: "Container",
  styles: _Container
});

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
export const UpgradeButton = (props) => (
  <Button {...props}>
    <PremiumIcon />
    {props.ctaCopy || 'Upgrade Now'}
  </Button>
);
